import { Button } from '@/components/common/button'
import { routes } from '@/config/routes'
import { useMixpanel } from '@/context/mixpanel'
import { cn } from '@/utils/cn'
import { Link } from 'react-router'

type DiscoverPage = 'vaults' | 'fixed-terms'

const DISCOVER_PAGES = [
  { value: 'vaults', label: 'Vaults', to: routes.root },
  { value: 'fixed-terms', label: 'Fixed term', to: routes.fixedTerm },
] as const satisfies ReadonlyArray<{ value: DiscoverPage; label: string; to: string }>

interface DiscoverNavigationProps {
  activePage: DiscoverPage
}

export const DiscoverNavigation = ({ activePage }: DiscoverNavigationProps) => {
  const { trackEvent } = useMixpanel()

  return (
    <nav
      aria-label="Discover opportunities"
      className="flex w-fit shrink-0 items-center gap-1 rounded-2xl border bg-surface p-1"
    >
      {DISCOVER_PAGES.map(({ value, label, to }) => {
        const isActive = value === activePage

        return (
          <Button
            key={value}
            variant="default"
            size="default"
            className={cn(
              'rounded-xl px-4 py-2 font-medium text-body-foreground',
              isActive && 'bg-background-100 hocus:text-heading-foreground text-heading-foreground'
            )}
            asChild
          >
            <Link
              to={to}
              prefetch="intent"
              aria-current={isActive ? 'page' : undefined}
              onClick={() =>
                trackEvent('Discover page selected', {
                  Page: label,
                })
              }
            >
              {label}
            </Link>
          </Button>
        )
      })}
    </nav>
  )
}
